<template>
  <div class="page-container">

    <!-- Banner区域 -->
    <section class="banner-section">
      <div class="banner-container">
        <img src="@/assets/eduserve/banner.png"
             :alt="$t('eduServices.banner.imageAlt')"
             class="banner-bg">
        <div class="banner-info-card">
          <div class="banner-info-title">{{ $t('eduServices.banner.title') }}</div>
          <div class="banner-info-desc">{{ $t('eduServices.banner.desc') }}</div>
        </div>
      </div>
    </section>

    <!-- 推荐产品 -->
    <section class="recommended-products">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">{{ $t('eduServices.recommended.title') }}</h2>

        </div>
        <div class="products-grid">
          <div class="product-card"
               v-for="(product, index) in recommendedProducts"
               :key="index">
            <div class="product-image">
              <img :src="product.image"
                   :alt="product.alt"
                   class="product-img">
            </div>
            <h3 class="product-name">{{ product.name }}</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 解决方案分类 -->
    <section class="solution-categories">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">{{ $t('eduServices.solutionCategories.title') }}</h2>

        </div>

        <!-- 导航项 -->
        <div class="nav-tabs-container">
          <div class="nav-tabs">
            <div class="nav-tab"
                 v-for="tab in navTabs"
                 :key="tab.key"
                 :class="{ active: activeTab === tab.key }"
                 @click="changeTab(tab.key)">
              {{ tab.label }}
            </div>
          </div>
        </div>

        <!-- 内容展示 -->
        <div class="content-display"
             :class="{ 'content-display-reverse': isImageLeft }">
          <div class="content-text">
            <h3 class="content-title">{{ currentTabContent.title }}</h3>
            <ul class="content-desc">
              <li v-for="(feature, index) in currentTabContent.features"
                  :key="index">
                {{ feature }}
              </li>
            </ul>
          </div>
          <div class="content-image">
            <img :src="currentTabContent.image"
                 :alt="currentTabContent.title"
                 class="tab-image">

          </div>
        </div>
      </div>
    </section>

    <!-- 解决方案 -->
    <section class="solutions">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">{{ $t('eduServices.solutions.title') }}</h2>

        </div>
        <div class="solutions-container">
          <div class="solution-item"
               style="background-color: white !important;"
               v-for="(solution, index) in solutions"
               :key="index"
               :class="{ active: activeSolution === index }"
               @click="toggleSolution(index)">
            <div class="solution-header">
              <div class="solution-icon">
                <img :src="solution.icon"
                     :alt="solution.title">
              </div>
              <h3 class="solution-title">{{ solution.title }}</h3>
            </div>
            <div class="solution-content">
              <p class="solution-description">{{ solution.description }}</p>
              <div class="solution-image">
                <img :src="solution.image"
                     :alt="solution.title">
              </div>
              <div class="solution-button">
                <button class="view-details-btn">{{ solution.buttonText }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 管理平台板块 -->
    <section class="management-platform">
      <div class="container">
        <div class="platform-header">
          <h2 class="platform-title">{{ $t('eduServices.managementPlatform.title') }}</h2>
          <p class="platform-description">
            {{ $t('eduServices.managementPlatform.desc') }}
          </p>
        </div>

        <div class="solution-items">
          <div class="platform-solution-item"
               v-for="(item, index) in platformSolutions"
               :key="index">
            <div class="platform-solution-item-image">
              <img :src="item.image"
                   :alt="item.alt">
            </div>
            <h3 class="platform-solution-item-title">{{ item.title }}</h3>
          </div>
        </div>

        <div class="platform-action">
          <button class="action-button">
            <img src="@/assets/eduserve/m1.png"
                 :alt="$t('eduServices.managementPlatform.action.alt')"
                 width="41"
                 height="38">
            {{ $t('eduServices.managementPlatform.action.text') }}
          </button>
        </div>
      </div>
    </section>
    <!-- 联系我们表单 -->

  </div>
</template>

<script>


export default {
  name: 'EducationSolution',
  components: {

  },
  data() {
    return {
      activeTab: 'teaching-assist',
      tabOrder: ['teaching-assist', 'process-optimize', 'device-manage'],
      tabAssets: {
        'teaching-assist': {
          image: require('@/assets/eduserve/space1.png'),
        },
        'process-optimize': {
          image: require('@/assets/eduserve/space2.png'),
        },
        'device-manage': {
          image: require('@/assets/eduserve/space3.png'),
        },
      },
      activeSolution: 0,
      solutionAssets: [
        {
          key: 'device',
          icon: require('@/assets/eduserve/solutionicon1.png'),
          image: require('@/assets/eduserve/solution1.png'),
        },
        {
          key: 'software',
          icon: require('@/assets/eduserve/solutionicon2.png'),
          image: require('@/assets/eduserve/solution2.png'),
        },
        {
          key: 'course',
          icon: require('@/assets/eduserve/solutionicon3.png'),
          image: require('@/assets/eduserve/solution3.png'),
        },
      ],
      platformSolutionAssets: [
        {
          key: 'innovation',
          image: require('@/assets/eduserve/platform1.png'),
        },
        {
          key: 'k12',
          image: require('@/assets/eduserve/platform2.png'),
        },
        {
          key: 'vocational',
          image: require('@/assets/eduserve/platform3.png'),
        },
        {
          key: 'university',
          image: require('@/assets/eduserve/platform4.png'),
        },
      ],
      recommendedProductAssets: [
        {
          key: 'light640',
          image: require('@/assets/eduserve/640.png'),
        },
        {
          key: 'light530',
          image: require('@/assets/eduserve/530.png'),
        },
        {
          key: 'markM20',
          image: require('@/assets/eduserve/m20.png'),
        },
        {
          key: 'lightBlue530',
          image: require('@/assets/eduserve/blue530.png'),
        },
      ],
      categoryAssets: [
        {
          key: 'homework',
          icon: require('@/assets/eduserve/solution1.png'),
        },
        {
          key: 'repair',
          icon: require('@/assets/eduserve/solution2.png'),
        },
        {
          key: 'centralControl',
          icon: require('@/assets/eduserve/solution3.png'),
        },
        {
          key: 'cloudResources',
          icon: '/solution5.png',
        },
        {
          key: 'deviceMonitoring',
          icon: '/solution5.png',
        },
        {
          key: 'aiAssistant',
          icon: '/solution6.png',
        },
      ],
      solutionCardAssets: [
        {
          key: 'innovation',
          image: '/solution-card1.jpg',
        },
        {
          key: 'k12',
          image: '/solution-card2.jpg',
        },
        {
          key: 'vocational',
          image: '/solution-card3.jpg',
        },
        {
          key: 'university',
          image: '/solution-card4.jpg',
        },
      ],
    };
  },
  computed: {
    eduServicesCopy() {
      const locale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'zh-CN'
      const messages =
        this.$i18n && this.$i18n.getLocaleMessage
          ? this.$i18n.getLocaleMessage(locale)
          : {}
      return messages.eduServices || {}
    },
    recommendedProducts() {
      const list =
        (this.eduServicesCopy.recommended &&
          this.eduServicesCopy.recommended.products) ||
        []
      return list.map((item, index) => {
        const asset = this.recommendedProductAssets[index] || {}
        return {
          name: item.name || '',
          alt: item.alt || item.name || '',
          image: asset.image || '',
        }
      })
    },
    navTabs() {
      const tabs =
        (this.eduServicesCopy.solutionCategories &&
          this.eduServicesCopy.solutionCategories.tabs) ||
        {}
      return this.tabOrder.map((key) => ({
        key,
        label: tabs[key] || '',
      }))
    },
    tabContents() {
      const tabContents =
        (this.eduServicesCopy.solutionCategories &&
          this.eduServicesCopy.solutionCategories.tabContents) ||
        {}
      return this.tabOrder.reduce((acc, key) => {
        const item = tabContents[key] || {}
        const asset = this.tabAssets[key] || {}
        acc[key] = {
          title: item.title || '',
          features: item.features || [],
          image: asset.image || '',
        }
        return acc
      }, {})
    },
    currentTabContent() {
      return this.tabContents[this.activeTab] || {
        title: '',
        features: [],
        image: '',
      }
    },
    solutions() {
      const list =
        (this.eduServicesCopy.solutions && this.eduServicesCopy.solutions.items) ||
        []
      return list.map((item, index) => {
        const asset = this.solutionAssets[index] || {}
        return {
          title: item.title || '',
          description: item.description || '',
          buttonText: item.buttonText || '',
          icon: asset.icon || '',
          image: asset.image || '',
        }
      })
    },
    platformSolutions() {
      const list =
        (this.eduServicesCopy.managementPlatform &&
          this.eduServicesCopy.managementPlatform.items) ||
        []
      return list.map((item, index) => {
        const asset = this.platformSolutionAssets[index] || {}
        return {
          title: item.title || '',
          alt: item.alt || item.title || '',
          image: asset.image || '',
        }
      })
    },
    categories() {
      const list =
        (this.eduServicesCopy.solutionCategories &&
          this.eduServicesCopy.solutionCategories.categories) ||
        []
      return list.map((item, index) => {
        const asset = this.categoryAssets[index] || {}
        return {
          title: item.title || '',
          description: item.description || '',
          icon: asset.icon || '',
        }
      })
    },
    solutionCards() {
      const list =
        (this.eduServicesCopy.solutionCategories &&
          this.eduServicesCopy.solutionCategories.solutionCards) ||
        []
      return list.map((item, index) => {
        const asset = this.solutionCardAssets[index] || {}
        return {
          title: item.title || '',
          image: asset.image || '',
        }
      })
    },
    activeTabIndex() {
      return this.tabOrder.indexOf(this.activeTab);
    },
    isImageLeft() {
      return this.activeTabIndex % 2 === 0;
    }
  },
  methods: {
    changeTab(tab) {
      this.activeTab = tab;
    },
    toggleSolution(index) {
      this.activeSolution = index;
    }
  }
};
</script>

<style scoped>
.page-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Banner样式 */
.banner-section {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.banner-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.banner-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.banner-info-card {
  position: absolute;
  left: 40px;
  bottom: 40px;
  width: 800px;
  height: 159px;
  background: rgba(255, 255, 255, 0.83);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 40px;
  box-sizing: border-box;
}

.banner-info-title {
  font-size: 34px;
  color: #333;
  line-height: 1.2;
  margin-bottom: 10px;
}

.banner-info-desc {
  font-size: 24px;
  color: #666;
  line-height: 1.4;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(46, 162, 250, 0.8) 0%,
    rgba(0, 123, 255, 0.6) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-content {
  text-align: center;
  color: white;
  max-width: 800px;
  padding: 0 20px;
}

.banner-title {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.banner-subtitle {
  font-size: 24px;
  margin-bottom: 30px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}

/* 管理平台板块样式 */
.management-platform {
  background: #f7f7f7;
  padding: 80px 0;
  position: relative;
  background-image: url("@/assets/eduserve/management-bg.png");
  background-size: cover;
  background-position: center;
}

.management-platform::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background-attachment: fixed;
  opacity: 0.1;
  z-index: 1;
}

.management-platform .container {
  position: relative;
  z-index: 2;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

.platform-header {
  text-align: center;
  margin-bottom: 60px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
}

.platform-title {
  font-size: 34px;
  font-weight: 600;
  color: #333;
  margin-bottom: 30px;
  line-height: 1.3;
}

.platform-description {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  max-width: 1000px;
  margin: 0 auto;
  text-align: justify;
}

.solution-items {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin-bottom: 60px;
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}

.platform-solution-item {
  text-align: center;
  background: transparent !important;
  border-radius: 15px;
  padding: 30px 20px;
  /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1); */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.platform-solution-item:hover {
  transform: translateY(-10px);
}

.platform-solution-item-image {
  margin-bottom: 20px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 10px;
}

.platform-solution-item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.platform-solution-item:hover .platform-solution-item-image img {
  transform: scale(1.05);
}

.platform-solution-item-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin: 0;
  line-height: 1.4;
}

.platform-action {
  text-align: center;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
}

.action-button {
  background: transparent;
  color: #333;
  border: none;
  padding: 15px 40px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 15px;
  border: 1px solid #2ea2fa;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  /* box-shadow: 0 5px 20px rgba(46, 162, 250, 0.3); */
}

.action-button:hover {
  transform: translateY(-2px);
}

.action-button i {
  font-size: 20px;
}

.banner-description {
  font-size: 18px;
  line-height: 1.6;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
  opacity: 0.8;
}

.banner-description p {
  margin: 0;
}

/* 推荐产品 */
.recommended-products {
  padding: 80px 0;
  background-color: #f8f9fa;
}

/* 导航标签 */
.nav-tabs-container {
  width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  margin-bottom: 60px;
}

.nav-tabs-container::-webkit-scrollbar {
  display: none;
}

.nav-tabs {
  display: flex;
  justify-content: center;
  gap: 40px;
  min-width: max-content;
  padding: 0 20px;
}

.nav-tab {
  font-size: 18px;
  color: #333;
  padding: 15px 30px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  font-weight: 500;
}

.nav-tab.active {
  color: #2ea2fa;
  border-bottom-color: #2ea2fa;
}

/* 内容展示 */
.content-display {
  display: flex;
  width: 1200px;
  height: 381px;
  background: #f7f7f7;
  margin: 40px auto 0;
  overflow: hidden;
}

.content-display-reverse {
  flex-direction: row-reverse;
}
.content-text {
  width: 518px;
  height: 381px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 120px;
  box-sizing: border-box;
}

.content-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0 0 16px;
}

.content-desc {
  list-style: none;
  padding: 0;
  margin: 0;
}

.content-desc li {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
}

.content-image {
  width: 683px;
  height: 381px;
  overflow: hidden;
}
.tab-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.content-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  background: rgba(46, 162, 250, 0.9);
  color: white;
  padding: 30px;
  width: 400px;
  border-radius: 0 0 0 15px;
}

.overlay-title {
  font-size: 24px;
  margin-bottom: 20px;
  font-weight: bold;
}

.overlay-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.overlay-features li {
  font-size: 16px;
  margin-bottom: 10px;
  padding-left: 20px;
  position: relative;
}

.overlay-features li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: white;
  font-weight: bold;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: 34px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
}

.section-subtitle {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin-top: 60px;
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

.product-card:hover {
  transform: translateY(-10px);
}

.product-image {
  margin-bottom: 20px;
}

.product-img {
  width: 100%;
  height: 200px;
  object-fit: contain;
}

.product-card {
  text-align: center;
  /* background: white; */
  border-radius: 15px;
  padding: 30px 20px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  max-width: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-image {
  margin-bottom: 20px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.product-name {
  font-size: 24px;
  color: #333;
  margin: 0 0 10px 0;
  font-weight: normal;
}

.product-desc {
  font-size: 16px;
  color: #666;
  margin: 0;
  text-align: center;
  line-height: 1.5;
}

/* 解决方案分类 */
.solution-categories {
  padding: 80px 0;
  background-color: #fff;
}

.categories-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  margin-top: 60px;
}

.category-card {
  /* background: white; */
  border-radius: 15px;
  padding: 20px;
  text-align: center;

  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.category-card:hover {
  transform: translateY(-5px);
}

.category-icon {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.category-icon img {
  width: 100%;
  height: auto;
  /* max-width: 200px; */
  object-fit: contain;
}

/* 解决方案 */
.solutions {
  padding: 80px 0;
  background-color: #f7f7f7;
}

.solutions-container {
  display: flex;
  flex-direction: row;
  gap: 30px;
  margin-top: 60px;
}

.solution-item {
  background: white;
  border-radius: 15px;
  padding: 30px;
  cursor: pointer;
  transition: all 0.3s ease;

  flex: 1;
  min-width: 300px;
  position: relative;
  overflow: hidden;
}

.solution-item:hover:not(.active) {
  transform: translateY(-2px);
}

.solution-item.active {
  flex: 2;
  min-width: 500px;
}

.solution-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  text-align: center;
}

.solution-icon {
  width: 100px;
  height: 100px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  /* background: #f8f9fa; */
}

.solution-icon img {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.solution-title {
  font-size: 24px;
  color: #333;
  font-weight: bold;
  margin: 0;
}

.solution-content {
  margin-top: 20px;
  padding-top: 20px;
  padding-bottom: 80px;

  position: relative;
}

.solution-description {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 30px;
}

.solution-image {
  width: 100%;
  height: 200px;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 30px;
}

.solution-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.solution-button {
  text-align: center;
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
}

.view-details-btn {
  background: #fff;
  border: 1px solid #2ea2fa !important;
  color: #2ea2fa;
  border: none;
  padding: 5px 30px;
  border-radius: 25px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* 联系我们 */
.contact-section {
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  padding: 80px 0;
  position: relative;
  background-color: #f7f7f7;
  background-size: cover;
  background-position: center;
  z-index: 1;
}

.contact-bg {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.contact-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.contact-content {
  text-align: center;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.contact-title {
  font-size: 34px;
  margin-bottom: 20px;
  font-weight: normal !important;
  color: #333;
}

.contact-description {
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 60px;
  font-weight: normal !important;
  color: #666;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.solution-cards {
  display: flex;
  gap: 30px;
  margin-bottom: 50px;
  justify-content: center;
  width: 100%;
}

.solution-cards-container {
  width: 100%;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.solution-cards-container::-webkit-scrollbar {
  display: none;
}

.solution-card {
  flex: 1;
  max-width: 280px;
  /* background: white; */
  border-radius: 15px;
  overflow: hidden;

  transition: transform 0.3s ease;
}

.solution-card:hover {
  transform: translateY(-5px);
}

.card-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-title {
  font-size: 18px;
  color: #333;
  padding: 20px;
  margin: 0;
  font-weight: normal;
  text-align: center;
}

.contact-button {
  text-align: center;
}

.get-solution-btn {
  background: white;
  border: 1px solid #2ea2fa !important;
  color: #333;
  padding: 15px 40px;
  border-radius: 15px;
  font-size: 18px;
  font-weight: normal;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
}

.chat-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

/* 联系我们表单 */
.contact-form-wrapper {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
}

.contact-header {
  margin-bottom: 60px;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .products-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
    max-width: 1000px;
  }

  .product-card {
    max-width: 100%;
    padding: 25px 15px;
  }

  .product-img {
    height: 180px;
  }

  .product-image {
    height: 180px;
  }

  /* 管理平台响应式 */
  .solution-items {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
    width: 100%;
    padding: 0 15px;
  }

  .platform-solution-item {
    width: 100%;
  }

  .platform-title {
    font-size: 30px;
  }

  .platform-description {
    font-size: 15px;
    max-width: 800px;
  }
}

@media (max-width: 768px) {
  .banner-section {
    height: 400px;
  }

  .banner-title {
    font-size: 32px;
  }

  .banner-subtitle {
    font-size: 18px;
  }

  .banner-description {
    font-size: 16px;
  }

  .section-title {
    font-size: 28px;
  }

  .nav-tabs-container {
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .nav-tabs-container::-webkit-scrollbar {
    display: none;
  }

  .nav-tabs {
    display: flex;
    gap: 20px;
    min-width: max-content;
    padding: 0 15px;
    justify-content: flex-start;
  }

  .solutions-container {
    flex-direction: column;
    gap: 20px;
  }

  .solution-item {
    min-width: 250px;
  }

  .solution-item.active {
    flex: 1;
    min-width: 300px;
  }

  .solution-header {
    flex-direction: row;
    gap: 15px;
    text-align: left;
  }

  .solution-icon {
    width: 50px;
    height: 50px;
  }

  .solution-icon img {
    width: 30px;
    height: 30px;
  }

  .solution-title {
    font-size: 20px;
  }

  .solution-content {
    padding-bottom: 70px;
  }

  .solution-button {
    bottom: 20px;
  }

  .nav-tab {
    font-size: 16px;
    padding: 12px 20px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .content-image {
    width: 100%;
    max-width: 800px;
    height: 300px;
  }

  .content-overlay {
    width: 300px;
    padding: 20px;
  }

  .products-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
    padding: 0 20px;
  }

  .product-card {
    max-width: 100%;
  }

  .product-img {
    width: 100%;
    max-width: 100%;
    height: 180px;
  }

  .product-image {
    height: 180px;
  }

  .categories-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  .cases-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .solution-cards-container {
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .solution-cards-container::-webkit-scrollbar {
    display: none;
  }

  .solution-cards {
    display: flex;
    gap: 20px;
    min-width: max-content;
    padding: 0 20px;
  }

  .solution-card {
    min-width: 280px;
    max-width: 280px;
    flex-shrink: 0;
  }

  .contact-container {
    padding: 0 15px;
  }

  .contact-title {
    font-size: 28px;
  }

  .contact-description {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .banner-section {
    height: 300px;
  }

  .products-grid {
    gap: 20px;
    padding: 0 15px;
  }

  .product-card {
    padding: 20px 15px;
  }

  .product-name {
    font-size: 20px;
  }

  .product-desc {
    font-size: 14px;
  }

  .banner-title {
    font-size: 24px;
  }

  /* 管理平台响应式 */
  .platform-title {
    font-size: 22px;
    padding: 0 15px;
  }

  .platform-description {
    font-size: 13px;
    padding: 0 15px;
  }

  .platform-solution-item {
    padding: 20px 15px;
  }

  .platform-solution-item-image {
    height: 150px;
  }

  .action-button {
    padding: 10px 25px;
    font-size: 14px;
  }

  .banner-subtitle {
    font-size: 16px;
  }

  .banner-description {
    font-size: 14px;
  }

  .recommended-products,
  .solution-categories,
  .success-cases,
  .contact-section {
    padding: 60px 0;
  }

  .section-title {
    font-size: 24px;
  }

  .nav-tabs-container {
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .nav-tabs-container::-webkit-scrollbar {
    display: none;
  }

  .nav-tabs {
    display: flex;
    gap: 15px;
    min-width: max-content;
    padding: 0 10px;
    justify-content: flex-start;
  }

  .solution-item {
    padding: 20px;
    min-width: 200px;
  }

  .solution-item.active {
    flex: 1;
    min-width: 250px;
  }

  .solution-header {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }

  .solution-icon {
    width: 40px;
    height: 40px;
  }

  .solution-icon img {
    width: 25px;
    height: 25px;
  }

  .solution-title {
    font-size: 18px;
  }

  .solution-description {
    font-size: 14px;
  }

  .solution-content {
    padding-bottom: 70px;
  }

  .solution-image {
    height: 150px;
  }

  .solution-button {
    bottom: 20px;
  }

  .solution-cards-container {
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .solution-cards-container::-webkit-scrollbar {
    display: none;
  }

  .solution-cards {
    display: flex;
    gap: 15px;
    min-width: max-content;
    padding: 0 15px;
  }

  .solution-card {
    min-width: 250px;
    max-width: 250px;
    flex-shrink: 0;
  }

  /* 管理平台响应式 */
  .solution-items {
    grid-template-columns: 1fr;
    gap: 20px;
    width: 100%;
    padding: 0 15px;
  }

  .platform-solution-item {
    width: 100%;
  }

  .platform-title {
    font-size: 26px;
  }

  .platform-description {
    font-size: 14px;
    padding: 0 20px;
  }

  .action-button {
    padding: 12px 30px;
    font-size: 16px;
  }

  .card-image {
    height: 150px;
  }

  .card-title {
    font-size: 16px;
    padding: 15px;
  }

  .contact-container {
    padding: 0 10px;
  }

  .get-solution-btn {
    padding: 12px 30px;
    font-size: 16px;
  }

  .chat-icon {
    width: 16px;
    height: 16px;
  }

  .nav-tab {
    font-size: 14px;
    padding: 10px 15px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .content-image {
    height: 250px;
  }

  .content-overlay {
    width: 100%;
    border-radius: 0 0 15px 15px;
  }

  .overlay-title {
    font-size: 20px;
  }

  .overlay-features li {
    font-size: 14px;
  }

  .categories-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .product-card {
    padding: 30px 20px;
    max-width: 400px;
  }

  .product-img {
    width: 100%;
    max-width: 300px;
    height: 200px;
  }

  .product-image {
    height: 200px;
  }

  .category-card {
    padding: 15px;
    min-height: 150px;
  }

  .category-icon img {
    max-width: 150px;
  }

  .case-content {
    padding: 20px;
  }
}
</style> 
